// src/components/Gallery.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules'; // Importando os módulos de funcionalidade

// Importando os estilos do Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../styles/Gallery.css'; // Nosso CSS personalizado

// --- IMPORTANTE: Importe suas fotos reais aqui ---
// Certifique-se de que elas estão na pasta src/assets/images/
import img1 from '../assets/foto1.jpeg';
import img2 from '../assets/foto2.jpeg';
import img3 from '../assets/foto3.jpeg';
import img4 from '../assets/foto4.jpeg';
import img5 from '../assets/foto5.jpeg';

// Colocamos as imagens em um array para facilitar
const photos = [
    { src: img1, alt: 'Caminhão Guincho TR Victor em atendimento' },
    { src: img2, alt: 'Transporte de veículo' },
    { src: img3, alt: 'Equipamento de reboque' },
    { src: img4, alt: 'Guincho plataforma' },
    { src: img5, alt: 'Atendimento 24 horas' },
];


const Gallery = () => {
  return (
    <section className="gallery-container" id="galeria">
      <h2>Equipe em Ação</h2>
      <p className="gallery-subtitle">Confira alguns de nossos atendimentos e equipamentos.</p>

      <Swiper
        // Módulos que vamos usar
        modules={[Navigation, Pagination, Autoplay, A11y]}
        spaceBetween={20} // Espaço entre os slides
        slidesPerView={1} // Quantos slides mostrar por vez (começa com 1 no mobile)
        navigation // Setinhas para passar
        pagination={{ clickable: true }} // Bolinhas embaixo
        loop={true} // Faz o carrossel ser infinito
        autoplay={{
            delay: 3500, // Passa sozinho a cada 3.5 segundos
            disableOnInteraction: false, // Continua passando mesmo se o usuário mexer
        }}
        // Configurações responsivas (Breakpoints)
        breakpoints={{
            // quando a tela for >= 768px (Tablets e PC)
            768: {
              slidesPerView: 2, // Mostra 2 fotos por vez
              spaceBetween: 30
            },
            // quando a tela for >= 1024px (PC grande)
            1024: {
                slidesPerView: 3, // Mostra 3 fotos por vez
                spaceBetween: 40
            }
        }}
        className="mySwiper"
      >
        {/* Mapeando nosso array de fotos para criar os slides */}
        {photos.map((photo, index) => (
            <SwiperSlide key={index}>
                <div className="slide-image-wrapper">
                 <img src={photo.src} alt={photo.alt} className="slide-image" />
                </div>
            </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Gallery;